
<div class="app-toast" :class="toastConfig.className">
    <div class="app-toast__content">
        <!-- Иконка -->
        <feather-icon
            v-if="toastConfig.isFeatherIcon"
            size="16"
            :icon="toastConfig.icon"
            class="app-toast__icon flex-shrink-0"
        />
        <b-avatar v-else size="16" class="app-toast__icon flex-shrink-0">
            <img
                width="18"
                height="18"
                :src="toastConfig.icon"
                :alt="variant"
            />
        </b-avatar>

        <!-- Контент: заголовок + текст + действие -->
        <div class="app-toast__body">
            <p v-if="title" class="app-toast__title">{{ title }}</p>
            <p v-if="text" class="app-toast__message">{{ text }}</p>
            <button
                v-if="action"
                class="app-toast__action"
                @click="handleAction"
            >
                <span :style="`color: ${toastConfig.textColor}`">
                    {{ action.label }}
                </span>
            </button>
        </div>

        <!-- Кнопка закрытия -->
        <span
            v-if="!hideClose"
            class="app-toast__close-button"
            @click="$emit('close-toast')"
        >
            <feather-icon
                size="18"
                icon="XIcon"
                class="app-toast__close-icon"
            />
        </span>
    </div>
</div>
